import { ReviewItemProps } from '@zola/zola-ui/src/components/PreAuthV3/ReviewItem';

export const reviewItems: ReviewItemProps[] = [
  {
    name: 'Ray',
    reviewText:
      'The interface was easy to use and I was able to figure out how it worked immediately without ever having purchased from a gift registry before. I l...',
    title: 'Easy and quick',
  },
  {
    name: 'Suzanne',
    reviewText:
      'I am invited to a bridal shower for my soon to be niece. The invitation said she was registered at Zola and at Target. Being familiar with Target a...',
    title: 'Better than Target',
  },
  {
    name: 'Cindy',
    reviewText: 'Easy and there’s no shipping charge!!!',
    title: 'Free shipping',
  },
];
